import script from "./CarouselAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./CarouselAdminPage.vue?vue&type=style&index=0&id=76775474&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76775474"]])

export default __exports__